import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SimuladorFreteComponent } from "./pages/simulador/simulador-frete.component";

const routes: Routes = [
  {
    path: "configuracoes-do-usuario/simulador-frete",
    component: SimuladorFreteComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class SimuladorFreteRoutingModule {}
